import { render, staticRenderFns } from "./ActiveInvites.vue?vue&type=template&id=b73e0c00&"
import script from "./ActiveInvites.vue?vue&type=script&lang=js&"
export * from "./ActiveInvites.vue?vue&type=script&lang=js&"
import style0 from "./ActiveInvites.vue?vue&type=style&index=0&id=b73e0c00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports